/**
 * Gender of the user.
 * It is used to properly address the user in the confirmation email at the end of the process.
 */
export enum UserTitleEnumeration {
	MALE = 'mister',
	FEMALE = 'madam',
}
